var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#121416"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2704_38967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1598 15.8843C21.1896 19.0867 23.9692 20.1524 24 20.166C23.9765 20.2411 23.5559 21.6847 22.5356 23.1758C21.6536 24.4649 20.7382 25.7493 19.2961 25.7759C17.8792 25.802 17.4235 24.9356 15.8036 24.9356C14.1841 24.9356 13.6779 25.7493 12.3366 25.802C10.9447 25.8546 9.88473 24.408 8.99539 23.1236C7.17814 20.4963 5.78939 15.6995 7.65414 12.4617C8.5805 10.8537 10.236 9.83548 12.0329 9.80937C13.3997 9.7833 14.6898 10.7289 15.5254 10.7289C16.3604 10.7289 17.9282 9.59172 19.5764 9.75874C20.2664 9.78745 22.2031 10.0374 23.4468 11.8578C23.3466 11.92 21.1358 13.2069 21.1598 15.8843ZM18.4969 8.02057C19.2358 7.12606 19.7332 5.88082 19.5975 4.64182C18.5323 4.68463 17.2443 5.35163 16.4803 6.24565C15.7955 7.03734 15.1959 8.3045 15.3577 9.51898C16.5449 9.61084 17.7578 8.91565 18.4969 8.02057Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2704_38967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4615,
    height: 22.7163,
    fill: "white",
    transform: "translate(6.76923 4.64182)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApple);
export default __webpack_public_path__ + "static/media/LogoApple.f489c1c30aa3cf083585421e21fe598c.svg";
export { ForwardRef as ReactComponent };